/* eslint-disable max-len */
import React, { FC } from 'react'
import { media, Breakpoints, themeObject } from 'Pages/landings/newLandings/common/style'
import styled from 'styled-components'

interface ComponentProps extends React.HTMLAttributes<unknown> {
	isCustomIconColor?: boolean
}

const StyledIcon = styled.svg<{ isCustomIconColor?: boolean }>`
	width: 24px;
	height: 24px;
	fill: ${({ isCustomIconColor }) =>
		isCustomIconColor ? themeObject.colors.malachite[500] : themeObject.colors.brand[500]};
	min-height: 24px;
	min-width: 24px;
	flex-shrink: 0;
	margin-right: 16px;
	${media('height: 26px; width: 26px;', Breakpoints.lx)}
	${media('height: 28px; width: 28px;', Breakpoints.xl)}
`

export const CheckIcon: FC<ComponentProps> = ({ isCustomIconColor }) => (
	<StyledIcon
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		isCustomIconColor={isCustomIconColor}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.567 10.3879C20.0584 10.9567 19.9957 11.8163 19.4269 12.3077L12.221 18.5336L8.55661 15.2629C7.99579 14.7624 7.94694 13.9019 8.44751 13.3411C8.94808 12.7803 9.8085 12.7315 10.3693 13.232L12.2502 14.9108L17.6472 10.2478C18.216 9.75638 19.0755 9.8191 19.567 10.3879Z"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.75 14C1.75 7.23451 7.23451 1.75 14 1.75C20.7655 1.75 26.25 7.23451 26.25 14C26.25 20.7655 20.7655 26.25 14 26.25C7.23451 26.25 1.75 20.7655 1.75 14ZM14 4.47222C8.73795 4.47222 4.47222 8.73795 4.47222 14C4.47222 19.262 8.73795 23.5278 14 23.5278C19.262 23.5278 23.5278 19.262 23.5278 14C23.5278 8.73795 19.262 4.47222 14 4.47222Z"
		/>
	</StyledIcon>
)
